import { DateField } from "@refinedev/mui";

import { CellContainer } from "../CellContainer";
import { CellDateProps } from "./types";
import { StyledDate } from "./styles";

export const CellDate = ({
  value,
  align = 'start',
  direction,
  gap,
  color,
  showTime = true,
}: CellDateProps) => {
  const isEmpty = value == null || value === '';

  return (
    <CellContainer
      align={align}
      direction={direction}
      gap={gap}
    >
      <StyledDate
        color={color}
        className={isEmpty ? 'empty' : ''}
      >
        {isEmpty ? '-' : (
          <>
            <DateField value={value} format="DD/MM/YYYY" />
            {showTime && <DateField value={value} format="HH:mm" />}
          </>
        )}
      </StyledDate>
    </CellContainer>
  );
};

CellDate.displayName = "CellDate";
